module.exports = __webpack_public_path__ + "static/hiragana-4b15b7070d8dca02fce7456022ff091f.jpg";